// ===================================================================
// 1. IMPORT ALL DEPENDENCIES AT THE TOP
// ===================================================================
import './prism/prism.css';
import './prism/prism-vsc-dark-plus.css';
import './prism/prism.js';

// This special import asks Parcel for the final URL of output.txt after it's
// been copied to the 'dist' build folder.
import dataUrl from 'url:./output.txt';

// ===================================================================
// 2. YOUR ORIGINAL LOGIC (with one tiny but crucial change)
// ===================================================================
document.addEventListener("DOMContentLoaded", () => {
    const contentWrapper = document.getElementById('content-wrapper');
    const contentContainer = document.getElementById('content-container');
    const speedSlider = document.getElementById('speed-slider');
    const loopToggle = document.getElementById('loop-toggle');

    let animationFrameId = null;
    let speed = 20;
    let isLooping = true;
    let direction = 1; 
    let preciseScrollTop = 0;

    async function loadAndFormatContent() {
        try {
            // THE CRITICAL CHANGE: Instead of a hardcoded string,
            // we use the 'dataUrl' variable that Parcel gives us.
            const response = await fetch(dataUrl);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const fileContent = await response.text();
            
            let finalHTML = ''; 
            const rawChunks = fileContent.split(/(<pre[\s\S]*?<\/pre>)/g);

            rawChunks.forEach(chunk => {
                if (!chunk || chunk.trim() === "") return;
                if (chunk.startsWith("<pre")) {
                    finalHTML += chunk;
                } else {
                    const textLines = chunk.trim().split(/\r?\n/g);
                    textLines.forEach(lineText => {
                        const trimmedLine = lineText.trim();
                        if (trimmedLine) {
                            finalHTML += `<p>${trimmedLine}</p>`;
                        }
                    });
                }
            });

            contentContainer.innerHTML = finalHTML;
            const codeBlocks = contentContainer.querySelectorAll('pre > code');
            codeBlocks.forEach(block => {
                if (!block.className) {
                    block.className = 'language-jsx'; 
                }
            });
            Prism.highlightAll();
        } catch (error) {
            console.error("Failed to load or format content:", error);
            contentContainer.innerHTML = `<p style="color: #ff8c8c;">Error: Could not load content.</p><p>${error}</p>`;
        }
    }
    
    // ... the rest of your functions (scrollStep, startScrolling, etc.) are perfect ...
    // ... no changes needed for them ...
    function scrollStep() {
        if (Math.abs(contentWrapper.scrollTop - preciseScrollTop) > 2) {
            preciseScrollTop = contentWrapper.scrollTop;
        }
        const scrollAmount = (speed / 50) * direction;
        preciseScrollTop += scrollAmount;
        const maxScrollTop = contentWrapper.scrollHeight - contentWrapper.clientHeight;
        if (direction === -1 && preciseScrollTop <= 0) {
            preciseScrollTop = 0;
            if (isLooping) {
                direction = 1;
            } else {
                stopScrolling();
            }
        } else if (direction === 1 && preciseScrollTop >= maxScrollTop) {
            preciseScrollTop = maxScrollTop;
            if (isLooping) {
                direction = -1;
            } else {
                stopScrolling();
            }
        }
        contentWrapper.scrollTop = preciseScrollTop;
        animationFrameId = requestAnimationFrame(scrollStep);
    }
    function startScrolling() {
        if (!animationFrameId) {
            preciseScrollTop = contentWrapper.scrollTop;
            animationFrameId = requestAnimationFrame(scrollStep);
        }
    }
    function stopScrolling() {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
        }
    }
    async function init() {
        speed = parseInt(speedSlider.value, 10);
        isLooping = loopToggle.checked;
        contentWrapper.addEventListener('dblclick', () => {
            direction *= -1;
            startScrolling();
        });
        speedSlider.addEventListener('input', (e) => {
            speed = parseInt(e.target.value, 10);
        });
        loopToggle.addEventListener('change', (e) => {
            isLooping = e.target.checked;
            const maxScrollTop = contentWrapper.scrollHeight - contentWrapper.clientHeight;
            if (isLooping && (contentWrapper.scrollTop <= 0 || (maxScrollTop - contentWrapper.scrollTop < 1))) {
                startScrolling();
            }
        });
        await loadAndFormatContent();
        contentWrapper.scrollTop = 0;
        startScrolling();
    }
    init();
});